import {
  APPOINTMENT_STATUS,
  RECEIPT_PAYMENT_MODE,
} from "../stores/queue-store/enums";

export enum QUEUE_TYPE {
  CHECKED_IN = "checkin",
  COMPLETED = "completed",
  BOOKED = "booked",
  FOLLOWUP = "followup",
  OTHERS = "others",
  BILLING = "billing",
  REQUESTED = "requested",
}

export const aptNoShowStatuses = [
  APPOINTMENT_STATUS.NO_SHOW,
  APPOINTMENT_STATUS.NO_SHOW_DOCTOR,
  APPOINTMENT_STATUS.NO_SHOW_STAFF,
];

export const aptCancelledStatuses = [
  APPOINTMENT_STATUS.CANCELLED,
  APPOINTMENT_STATUS.DOCTOR_CANCELLED,
  APPOINTMENT_STATUS.STAFF_CANCELLED,
];

export const rescheduledStatuses = [
  APPOINTMENT_STATUS.RESCHEDULED,
  APPOINTMENT_STATUS.DOCTOR_RESCHEDULED,
  APPOINTMENT_STATUS.STAFF_RESCHEDULED,
];

export const paymentModeItems = [
  {
    label: "Cash",
    value: RECEIPT_PAYMENT_MODE.CASH,
    key: RECEIPT_PAYMENT_MODE.CASH,
  },
  {
    label: "Credit Card",
    value: RECEIPT_PAYMENT_MODE.CREDIT_CARD,
    key: RECEIPT_PAYMENT_MODE.CREDIT_CARD,
  },
  {
    label: "Debit Card",
    value: RECEIPT_PAYMENT_MODE.DEBIT_CARD,
    key: RECEIPT_PAYMENT_MODE.DEBIT_CARD,
  },
  {
    label: "Paytm",
    value: RECEIPT_PAYMENT_MODE.PAYTM,
    key: RECEIPT_PAYMENT_MODE.PAYTM,
  },
  {
    label: "GPay",
    value: RECEIPT_PAYMENT_MODE.GPAY,
    key: RECEIPT_PAYMENT_MODE.GPAY,
  },
  {
    label: "UPI",
    value: RECEIPT_PAYMENT_MODE.UPI,
    key: RECEIPT_PAYMENT_MODE.UPI,
  },
  {
    label: "Other",
    value: RECEIPT_PAYMENT_MODE.OTHER,
    key: RECEIPT_PAYMENT_MODE.OTHER,
  },
];

export enum FollowupMessagePurpose {
  FOLLOWUP_REMINDER = "Follow-up",
  FOLLOWUP_ACCEPTANCE_RESPONSE = "flw-yes",
  FOLLOWUP_REJECTION_RESPONSE = "flw-no",
  FOLLOWUP_RESCHEDULE_RESPONSE = "flw-res",
  FOLLOWUP_SLOT_CONFIRMATION_RESPONSE = "flw-slot-conf",
  FOLLOWUP_FEELING_BETTER_RESPONSE = "flw-feel-btr",
  FOLLOWUP_RESCHEDULE_CONFIRMATION = "flw-res-cnf",

  APPOINTMENT_REMINDER = "apt-rem",
  APPOINTMENT_REMINDER_YES_RESPONSE = "apt-rem-yes",
  APPOINTMENT_REMINDER_NO_RESPONSE = "apt-rem-no",
  APPOINTMENT_REMINDER_RESCHEDULE_RESPONSE = "apt-rem-res",
  APPOINTMENT_REMINDER_NO_LATER_DATE_RESPONSE = "apt-rem-no-later-date",
  APPOINTMENT_REMINDER_NO_FEELING_BETTER_RESPONSE = "apt-rem-no-feeling-better",
}
